import React from "react"
import { Main, CenterPiece, Button, OverviewItemImage, ButtonA,SpanButton,MainOverview,ReturnButton,DivContainer,POverview,H2Overview,LabelLanguage } from "../styles"
import { useEffect } from "react"
import { useState } from "react"
import { Loading } from "./Loading"
import { useGameProps } from "../../shared/useGameProps"
import eduboxLogo from "../../../assets/img/EDUbox_cut_no_tag@2x.jpg";





export const NotFound = () => {
  const { gameId, strapiUrl } = useGameProps()
  const [data, setData] = useState(null)
  const [pending, setPending] = useState(true)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    fetch(`${strapiUrl}/api/co-op-games/`)
      .then(response => response.json())
      .then(result => {
        console.log("NotFound: ", result)
        setData(result?.data || [])
        setSuccess(true)
      })
      .catch(error => console.log("error", error))
      .finally(() => {
        setPending(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClick = id => {
    window.open(`?game-id=${id}`, '_blank');
  }

  if (pending) return <Loading />
  if (success && data?.length > 0)
    return (
      <DivContainer>
        
          {gameId && (
            <div>
              <b>Game not found</b>
            </div>
          )}
          <OverviewItemImage src={eduboxLogo} alt="EDUbox logo" />
          <ReturnButton href="http://tools.vrtinnovatie.be/EDUbox/games/" role="button" tabIndex="0">&#8676; Overzicht</ReturnButton>
          <H2Overview>Co-op spel</H2Overview>
          <POverview>Co-op spel spel is een interactieve tool van EDUbox van VRT.<br />
          De volgende tools zijn deel van dit aanbod:</POverview>
          <MainOverview>
          {data.map((game, index) => 
              game.attributes.visible_for_teacher === true && (
                <ButtonA
                  key={index}
                  href="#"
                  className="overview-item"
                  role="button"
                  tabIndex="0"
                  onClick={() => handleClick(game.attributes.game_id)}
                >
                  {game.attributes.game_title} {game.attributes.lang_label !== "" && (<LabelLanguage>{game.attributes.lang_label}</LabelLanguage>)}
                  <SpanButton>&#10142;</SpanButton>
                </ButtonA>
              )
            )}

          </MainOverview>
        
      </DivContainer>
    )
  if (success && data?.length === 0)
    return (
      <Main>
        <CenterPiece>
          {gameId && (
            <div>
              <b>Game not found</b>
            </div>
          )}
          <div>No games available</div>
        </CenterPiece>
      </Main>
    )
  return (
    <Main>
      <CenterPiece>
        <div>
          <b>Game not found</b>
        </div>
      </CenterPiece>
    </Main>
  )
}
